import { IconButton, styled } from "@mui/material";
import { Refresh as RefreshIcon, Texture as TextureIcon } from '@mui/icons-material';
import { useState } from 'react';
import { useAppDispatch } from "../../Common/_hooks/useAppDispatch";
import { GetProductLabData } from "../../UIData/_actions/DesignLabActions";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../Common/_hooks/useAppSelector";
import LabTexturePreview from './LabTexturePreview';

const DevToolsGroup = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  margin: '0 8px',
  padding: '3px 5px 3px 10px',
  border: '1px solid rgba(252, 245, 127, 0.45)',
  borderRadius: 8,
  background: 'rgba(252, 245, 127, 0.08)',
  color: '#FCF57F',
  flexShrink: 0,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: 0,
    margin: '0 6px',
    padding: '3px 5px',
  },
}));

const DevToolsLabel = styled('span')(({ theme }) => ({
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: '0.08em',
  lineHeight: 1.2,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  borderRight: '1px solid rgba(252, 245, 127, 0.3)',
  paddingRight: 8,
  [theme.breakpoints.down('md')]: {
    borderRight: 0,
    paddingRight: 0,
    fontSize: 8,
  },
}));

const DevToolsButtons = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
});

export default function LabDevTool() {
  return process.env.NODE_ENV === 'development' ? <DevelopmentLabDevTool /> : null;
}

function DevelopmentLabDevTool() {
  const dispatch = useAppDispatch()
  const [t] = useTranslation('design-lab')
  const [texturePreviewOpen, setTexturePreviewOpen] = useState(false);

  const activeProductId = useAppSelector(state => state.get('UIData').get('designLab').get('activeProductId'));
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(activeProductId)));

  return <>
    <DevToolsGroup role="group" aria-label={t('Dev tools')}>
      <DevToolsLabel>{t('Dev tools')}</DevToolsLabel>
      <DevToolsButtons>
        <IconButton
          size="small"
          sx={{ color: 'inherit' }}
          onClick={() => {
            if (!productData) return;
            dispatch(GetProductLabData(productData.get('slug')));
          }}
          title={t('Refresh Lab Data')}
          aria-label={t('Refresh Lab Data')}
        >
          <RefreshIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: 'inherit' }}
          title={t('View 3D texture')}
          aria-label={t('View 3D texture')}
          onClick={() => setTexturePreviewOpen(true)}
        ><TextureIcon fontSize="small" /></IconButton>
      </DevToolsButtons>
    </DevToolsGroup>
    <LabTexturePreview open={texturePreviewOpen} onClose={() => setTexturePreviewOpen(false)} />
  </>;
}
